/**
 * Aviso no contexto (contrato `InlineAlert` do catalogo do design system).
 *
 * PROMOVIVEL: recebe tom e conteudo, e nao sabe o que e card, relatorio ou sessao.
 *
 * Existe porque aviso escrito como paragrafo solto some no meio do painel: o "Card ignorado - ..."
 * e o alerta de regerar ficavam como uma linha laranja qualquer, do mesmo peso do texto ao redor.
 * Aqui o tom vira desenho (barra na lateral e fundo lavado), sem virar caixa pesada.
 *
 * TERCEIRA COPIA (NIG, Report Viewer, e aqui). A regra escrita nas duas anteriores era subir para
 * `@ledger-glass/react` nesta hora; a decisao de 2026-09-29 foi copiar mais uma vez e promover
 * depois (spec 0008, "Promocao ao pacote"), para entregar o manager sem mexer no repositorio do
 * design system nem em producao.
 *
 * Isto e DIVIDA REGISTRADA, nao regra abandonada: a partir daqui sao tres implementacoes da mesma
 * peca evoluindo em paralelo. Quem for promover, compare as tres primeiro - hoje sao identicas por
 * construcao, e o que tiver divergido dira o que cada app precisou.
 */

import type { ReactNode } from 'react'

/**
 * PRIMEIRA DIVERGENCIA das tres copias (2026-09-29): `positive` so existe aqui. O onboarding cria
 * registros, e criacao precisa de confirmacao - "Conexao criada" nao pode sair com a mesma cor de
 * um aviso. NIG e Viewer nao tem fluxo de criacao e nao precisaram dele.
 *
 * Anotado de proposito: quando as tres subirem para o pacote, esta e a diferenca a preservar.
 */
export type AlertTone = 'info' | 'warning' | 'danger' | 'positive'

export interface AlertProps {
  tone?: AlertTone
  children: ReactNode
  /** Acao de recuperacao: "Tentar de novo", "Limpar filtros". */
  action?: ReactNode
}

export function Alert({ tone = 'info', children, action }: AlertProps) {
  return (
    <div className={`alert alert--${tone}`} role={tone === 'info' ? undefined : 'alert'}>
      <div className="alert__body">{children}</div>
      {action === undefined ? null : <div className="alert__action">{action}</div>}
    </div>
  )
}
